/*
*   @site           Preloaded: Site
*   @function       Module: Media Carousel
*   @author         Last17
*   @copyright      Copyright 2025, Preloaded.com
*   @version        0.01
*
*********************************************************************************************/


//-----------------------------------------------
// Imports
//-----------------------------------------------
import ModuleCarousel from '../_templates/ModuleCarousel';
import Player from '@vimeo/player';

//-----------------------------------------------
// Class Definition
//-----------------------------------------------
export default class ModuleCarouselMedia extends ModuleCarousel {

  //-----------------------------------------------
  // Init
  //-----------------------------------------------
  init() {
    //Main carousel functionality
    super.init();
  }


  //-----------------------------------------------
  // Slide Content Init
  //-----------------------------------------------
  slideContentInit(id, element, type) {
    let data = {};

    //Video
    if(type === 'video') {
      let iframe = element.querySelector('iframe');
      if(iframe) {
        //Create a player
        data.player = new Player(iframe);

        //On pause
        data.player.on('pause', function(id, data) {
          this.videoPause(id);
        }.bind(this, id));

        //On play
        data.player.on('play', function(id, data) {
          this.videoPlay(id);
        }.bind(this, id));

        //On loaded, cross fade it in
        data.player.on('loaded', function(id, data) {
          this.videoLoaded(id);
        }.bind(this, id));

        //playButton.setAttribute()
      }
    }

    //Default
    return data;
  }


  //-----------------------------------------------
  // Video Play
  //-----------------------------------------------
  videoPlay(id) {
    //Add the playing class
    this.slides[id].element.classList.add('playing');

    //Try and play (old code)
    /*
    try {
      this.slides[id].content.player.play();
    } catch (error) {
      
    }*/
  }


  //-----------------------------------------------
  // Video Pause
  //-----------------------------------------------
  videoPause(id) {
    this.slides[id].element.classList.remove('playing');
  }

  
  //-----------------------------------------------
  // Video Loaded
  //-----------------------------------------------
  videoLoaded(id) {
    this.slides[id].element.classList.add('loaded');
  }
}